<template>
    <div class="cms" v-loading.fullscreen.lock="loading">
        <div style="100%">
            <el-header>
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item v-for="path in paths" :key="path.id">
                        <span @click="onclickPath(path.id)" style="cursor: pointer;">{{path.title}}</span>
                    </el-breadcrumb-item>
                </el-breadcrumb>
                <div style="position: relative;">
                    <el-button icon="el-icon-plus" @click="addColumn">新建栏目</el-button>
                    <el-button v-if="columnId !== null" icon="el-icon-plus" @click="addArticle">新建文章</el-button>
                    <el-button v-if="columnId !== null" icon="el-icon-plus" @click='uploadType = true'>批量上传</el-button>
                    <el-popconfirm confirmButtonText='确定'
                                   cancelButtonText='取消'
                                   icon="el-icon-info"
                                   iconColor="red"
                                   title="确定要批量删除吗？"
                                   @confirm="doRemoveList"
                                   v-if='removeList.length != 0'>
                        <template #reference>
                            <el-button>批量删除</el-button>
                        </template>
                    </el-popconfirm>
                </div>
                <div class="paddtidi">
                    政府公开页面网址：http://{{zonezf.code}}.czyjsgk.com:7000/#/?id={{zonezf.zfgkColumnId}}
                </div>
            </el-header>
            <el-main v-if='uploadType && columnId !== null'>
                <el-upload multiple
                           ref="upload"
                           action=""
                           :on-preview="handlePreview"
                           :on-remove="handleRemove"
                           :file-list="fileList"
                           :on-change="handleChange"
                           :auto-upload="false"
                           :http-request="uploadFile">
                    <template #trigger>
                        <el-button size="small" type="primary">选取文件</el-button>
                    </template>
                    <el-button style="margin-left: 133px;" size="small" type="success" @click="submitUpload">上传</el-button>
                </el-upload>
            </el-main>
            <!-- <draggable :list="items" tag="el-icon-rank" :component-data="getComponentData()" item-key="name">
                <template #item="{element}"> -->
            <el-table :data="items" row-key="id" style="width: 100%" @selection-change="handleSelectionChange" highlight-current-row border element-loading-text="加载中" size="small">
                <el-table-column type="selection" width="40" />
                 <el-table-column label="顺序" width="50" class-name="draggable">
                        <template #default="scope">
                            <i class="el-icon-rank movelist" style="cursor: move;"></i>
                        </template>
                </el-table-column> 
                <el-table-column label="id" width="250">
                    <template #default="scope">
                        <span>{{scope.row.id}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="标题">
                    <template #default="scope">
                        <span style="cursor: pointer;" @click="onclickTitleAsync(scope.row)"><i v-if="scope.row.type=='column'" class="el-icon-folder"></i> {{scope.row.title}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="公开日期">
                    <template #default="scope">
                        {{scope.row.date}}
                    </template>
                </el-table-column>
                <el-table-column label="oper">
                    <template #default="scope">
                        <el-button @click="edit(scope.row)" size="small">编辑</el-button>
                        <el-button @click="move(scope.row)" size="small">移动</el-button>
                        <el-popconfirm title="确定删除吗？" @confirm="removeAsync(scope.row)">
                            <template #reference>
                                <el-button size="small">删除</el-button>
                            </template>
                        </el-popconfirm>
                    </template>
                </el-table-column>
            </el-table>
            <!-- </template>
            </draggable> -->
            <el-dialog title="栏目编辑" v-model="dialogColumn" :close-on-click-modal="false" width="30%">
                {{column.id}}
                标题
                <el-input v-model="column.title"></el-input>
                公开时间
                <el-date-picker value-format="YYYY-MM-DD" v-model="column.date" type="date" placeholder="选择日期">
                </el-date-picker>
                <template #footer>
                    <span class="dialog-footer">
                        <el-button @click="dialogColumn = false">取 消</el-button>
                        <el-button type="primary" @click="saveColumnAsync">保存</el-button>
                    </span>
                </template>
            </el-dialog>
            <el-dialog title="移动目标" v-model="dialogMove" :close-on-click-modal="false" custom-class="dialog-large" :destroy-on-close="true" v-loading="loadingMove">
                <el-tree :load="loadColumns" lazy ref="tree">
                </el-tree>
                <template #footer>
                    <span class="dialog-footer">
                        <el-button @click="dialogMove = false">取 消</el-button>
                        <el-button type="primary" @click="moveAsync">保存</el-button>
                    </span>
                </template>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import { columnInsert,articleInsert,columnList, columnAddOrUpdate, articleAddOrUpdate, columnDelete, articleDelete, publicList, articleImport } from '@/api/cms.js'
    import { zone } from '@/api/zone.js'
    import axios from 'axios'
    import baseUrl from '@/api/config.js'
    import draggable from 'vuedraggable'
    import Sortable from 'sortablejs'

    export default {
        data() {
            return {
                topColumns: [],
                items: [],
                paths: [{
                    id: null,
                    title: '首页'
                }],
                column: Object,
                currItemId: String,
                dialogColumn: false,
                dialogMove: false,
                loading: true,
                loadingMove: false,
                formInline: {
                    page: 1,
                    limit: 10,
                    varLable: '',
                    varName: ''
                },
                nshow: true, //switch开启
                fshow: false, //switch关闭
                editFormVisible: false, //控制编辑页面显示与隐藏
                title: '添加',
                baseurl: baseUrl.baseUrl.cms,
                uploadRequestHeaders: {
                    Authorization: 'Bearer ' + ''
                },
                columnId: null,
                fileData: '', // 文件上传数据（多文件合一）
                fileList: [], // upload多文件数组
                uploadType: false,
                removeList: [],
                lastId: '',
                parentId: '',
                activeNames: '',
                zonezf:''
            }
        },
        components: {
            draggable,
        },
        created() {
            this.init()
        },
        mounted() {
            this.rowDrop()
            this.zongFo()
        },
        methods: {
            zongFo() {
                zone().then(res => {
                    this.zonezf = res
                })
            },
            //拖拽
            rowDrop() {
                const tbody = document.querySelector('.el-table__body-wrapper tbody')
                const _this = this
                Sortable.create(tbody, {
                    handle: ".movelist",
                    disabled: false,
                    onEnd({ newIndex, oldIndex }) {
                        //数据长度为1不能拖拽
                        if (_this.items.length == 1) {
                            return
                        }
                        const currRow = _this.items.splice(oldIndex, 1)[0]
                        _this.items.splice(newIndex, 0, currRow)
                        let oldrowid = currRow.id //当前移动的id
                        let nooldrowid = ''   //插入到的位置
                        let position = ''    //之前还是之后
                        if (newIndex == _this.items.length - 1) {
                            nooldrowid = _this.items[Number(newIndex) - 1].id
                            position = 'after'
                        } else {
                            nooldrowid = _this.items[Number(newIndex) + 1].id
                            position = 'before'

                        }
                        if (currRow.type == 'column') {
                            _this.moveColumn(oldrowid, nooldrowid, position)
                        } else {
                            _this.moveArticle(oldrowid, nooldrowid, position)
                        }
                        //console.log(position,'列表', _this.items, '移动的项目', currRow, '移动的项目名称', oldrowid, oldIndex, '要插入的项目', nooldrowid,newIndex)
                    },
                    animation: 500
                })
            },
            //移动栏目
            async moveColumn(oldrowid, nooldrowid, position) {
                let data = {
                    id: oldrowid,
                    targetId: nooldrowid,
                    position: position
                }
                let res = await columnInsert(data)
            },
            //移动文章
            async moveArticle(oldrowid, nooldrowid, position) {
                let data = {
                    id: oldrowid,
                    targetId: nooldrowid,
                    position: position
                }
                let res = await articleInsert(data)
            },
            async moveArticleAsync(articleId, targetColumnId) {
                this.loading = true
                let body = {
                    id: articleId,
                    columnId: targetColumnId
                }
                let response = await articleAddOrUpdate(body)
                if (response.status === 0) {
                    this.$message('已移动')
                    this.loading = false
                }
            },
            async moveColumnAsync(columnId, targetColumnId) {
                this.loading = true
                let body = {
                    id: columnId,
                    parentId: targetColumnId
                }
                let response = await columnAddOrUpdate(body)
                if (response.status === 0) {
                    let idx = this.items.findIndex(e => e.id == this.currItemId)
                    this.items.splice(idx, 1)
                    this.$message('已移动')
                }
                this.loading = false
            },
            async moveAsync() {
                let idSelected = this.$refs.tree.getCurrentNode().id
                let item = this.items.find(e => e.id == this.currItemId)
                if (item.type == 'column') {
                    this.loadingMoving = true
                    if (item.id !== idSelected) {
                        await this.moveColumnAsync(item.id, idSelected)
                        this.loadingMoving = false
                    } else {
                        this.$message.error('无法移动到自身')
                    }
                }else if (item.type == 'article') {
                    this.loadingMoving = true
                    await this.moveArticleAsync(item.id, idSelected)
                    let idx = this.items.findIndex(e => e.id == this.currItemId)
                    this.items.splice(idx, 1)
                    this.loadingMoving = false
                    
                }
                this.dialogMove = false
            },
            move(item) {
                this.currItemId = item.id
                this.dialogMove = true
                this.loading = false
            },
            handlePreview(file) {
                console.log(file);
            },
            //移除
            handleRemove(file, fileList) {
                this.fileList = fileList;
                // return this.$confirm(`确定移除 ${ file.name }？`);
            },
            //监控上传文件列表
            handleChange(file, fileList) {
                let existFile = fileList.slice(0, fileList.length - 1).find(f => f.name === file.name);
                if (existFile) {
                    this.$message.error('当前文件已经存在!');
                    fileList.pop();
                }
                this.fileList = fileList;
            },
            // 上传文件
            uploadFile(file) {
                this.fileData.append('files', file.file); // append增加数据
            },
            // 上传到服务器
            async submitUpload() {
                const isLt100M = this.fileList.every(file => file.size / 1024 / 1024 < 100);
                if (!isLt100M) {
                    this.$message.error('请检查，上传文件大小不能超过100MB!');
                } else {
                    this.loading = true
                    this.fileData = new FormData(); // new formData对象
                    this.$refs.upload.submit(); // 提交调用uploadFile函数
                    let res = await articleImport({
                        columnId: this.columnId
                    }, this.fileData)
                    if (res.status == 0) {
                        this.$message({
                            message: "上传成功",
                            type: 'success'
                        });
                        this.onclickPath(this.columnId)
                        this.fileList = [];
                    }
                    this.loading = false
                }
            },
            doRemoveList() {
                this.removeList.forEach(item => {
                    if (item.type == 'column')
                        this.removeColumnAsync(item)
                    else if (item.type == 'article')
                        this.removeArticleAsync(item)
                })
            },
            addArticle() {
                let routeData = this.$router.resolve({
                    name: '文章',
                    query: {
                        articleId: null,
                        columnId: this.paths[this.paths.length - 1].id
                    }
                })
                window.open(routeData.href, '_blank')
            },
            inputChanged(value) {
                this.activeNames = value;
            },
            getComponentData() {
                return {
                    onChange: this.handleChange,
                    onInput: this.inputChanged,
                    wrap: true,
                    value: this.activeNames
                };
            },
            handleSelectionChange(val) {
                this.removeList = val
            },
            edit(item) {
                if (item.parentId !== undefined) {
                    delete item.parentId
                }
                this.column = Object.assign({}, item)
                this.column.parentId = this.parentId
                this.dialogColumn = true
            },
            async removeAsync(item) {
                if (item.type == 'column')
                    await this.removeColumnAsync(item)
                else if (item.type == 'article')
                    await this.removeArticleAsync(item)
            },
            async onclickPath(id) {
                this.uploadType = false
                this.columnId = id
                this.parentId = id
                await this.switchColumnByIdAsync(id)
                let idx = this.paths.findIndex(e => e.id == id)
                this.paths.splice(idx + 1)
            },
            async saveColumnAsync() {
                try {
                    let body = this.column
                    if (body.type == "article") {
                        delete body.type
                        let response = await articleAddOrUpdate(body)
                        if (response.status === 0) {
                            body.id = response.id
                            body.type = 'article'
                            this.items.push(body)
                            this.items.find(e => e.id == body.id).title = body.title
                            this.dialogColumn = false
                            this.$message('已保存')
                            this.loading = false
                            this.onclickPath(this.columnId)
                        } else
                            this.$message.error('错误 ' + response.phrase)
                    } else {
                        let response = await columnAddOrUpdate(body)
                        if (response.status === 0) {
                            if (this.isEmptyStr(this.column.id)) {
                                body.id = response.id
                                body.type = 'column'
                                this.items.push(body)
                            }
                            this.items.find(e => e.id == body.id).title = body.title
                            this.dialogColumn = false
                            this.$message('已保存')
                            this.loading = false
                            this.onclickPath(this.columnId)
                        }
                    }
                } catch (ex) {
                    this.$message.error('错误 ' + ex)
                } finally { }
            },
            addColumn() {
                this.column = {
                    title: '',
                    parentId: this.paths[this.paths.length - 1].id
                }
                if (!this.column.parentId) {
                    this.column.parentId = this.parentId ? this.parentId : this.zonezf.zfgkColumnId
                }
                this.dialogColumn = true
            },
            async onclickTitleAsync(item) {
                if (item.type == 'column') {
                    this.columnId = item.id
                    this.parentId = item.id
                    this.paths.push({
                        id: item.id,
                        title: item.title
                    })
                    axios({
                        method: 'get',
                        url: `${this.baseurl}cms/public/list?columnId=${item.id}`,
                    }).then(res => {
                        this.items = res.data.items
                        if (this.items.length !== 0) {
                            this.lastId = this.items[this.items.length - 1].id
                        }
                        this.loading = false
                    }).catch(err => {
                        this.$message.error('错误' + err)
                    })
                } else if (item.type == 'article') {
                    this.loading = false
                    let routeData = this.$router.resolve({
                        name: '文章',
                        query: {
                            articleId: item.id,
                            columnId: this.paths[this.paths.length - 1].id
                        }
                    })
                    window.open(routeData.href, '_blank')
                    // this.edit(item)
                }
            },
            async init() {
                let res = await columnList()
                if (res.status == 0) {
                    this.items = res.columns
                    this.topColumns = res.columns
                    this.parentId = res.parent.id
                    for (let item of this.items) {
                        item.type = 'column'
                    }
                }
                this.loading = false
            },
            options() {

            },
            isEmptyStr(val) {
                if (!val && val != 0)
                    return true
                if (!typeof (val) == 'string')
                    return false
                if (val.replace(/\s*/g, "") == "")
                    return true
                return false
            },
            async switchColumnByIdAsync(id) {
                this.loading = true
                this.items = []
                let url = ''
                if (id == null) {
                    await columnList()
                        .then(res => {
                            this.items = res.columns
                            this.loading = false
                            for (let item of this.items)
                                item.type = 'column'
                        }).catch(err => {
                            this.$message.error('错误' + err)
                        })
                } else if (id !== null && this.paths.length > 1) {
                    axios({
                        method: 'get',
                        url: `${this.baseurl}cms/public/list?columnId=${id}`,
                    }).then(res => {
                        this.items = res.data.items
                        if (this.items.length !== 0) {
                            this.lastId = this.items[this.items.length - 1].id
                        }
                        this.loading = false
                    }).catch(err => {
                        this.$message.error('错误' + err)
                    })
                }
            },
            async removeColumnAsync(column) {
                this.loading = true
                try {
                    let body = {
                        id: column.id
                    }
                    let response = await columnDelete(body)
                    if (response.status === 0) {
                        let idx = this.items.findIndex(e => e.id == column.id)
                        this.items.splice(idx, 1)
                        this.$message('已删除')
                        this.loading = false
                    }
                } catch (ex) {
                    this.$message.error('错误 ' + ex)
                } finally { }
            },
            async removeArticleAsync(article) {
                this.loading = true
                try {
                    let body = {
                        id: article.id
                    }
                    let response = await articleDelete(body)
                    if (response.status === 0) {
                        let idx = this.items.findIndex(e => e.id == article.id)
                        this.items.splice(idx, 1)
                        this.$message('已删除')
                        this.loading = false
                    }
                } catch (ex) {
                    this.$message.error('错误 ' + ex)
                } finally { }
            },
            async loadColumns(node, resolve) {
                if (node.level === 0) {
                    return resolve(this.topColumns.map(e => {
                        return {
                            id: e.id,
                            label: e.title
                        }
                    }))
                }
                let response = await columnList({
                    parentId: node.data.id
                }).then(res => {
                    return resolve(res.columns.map(e => {
                        return {
                            id: e.id,
                            label: e.title
                        }
                    }))
                })
            },
        }
    }
</script>

<style scoped>
    .paddtidi {
        padding: 5px 0;
        color: #606266;
        font-size: 15px;
    }
    .el-header {
        padding: 0;
        height: auto !important;
    }
    /deep/ .el-table__row{
        cursor:pointer !important;
    }
    .el-table /deep/.cell{
        text-align:center;
    }
    .cms {
        width: 100%;
        padding: 50px;
    }

    .draggable {
    }
</style>